import type { RefObject } from 'react';
import type { HeadingRef } from '../../../atoms/heading/Heading.data';
import { findTransitionController } from '../../../../util/core-transition-component';

interface GridListItemRefs {
  elementRef?: RefObject<HTMLElement | null>;
  lineRef?: RefObject<HTMLDivElement | null>;
  headingRef?: RefObject<HeadingRef | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, lineRef, headingRef }: GridListItemRefs,
): void {
  const title = findTransitionController(headingRef);

  if (elementRef?.current) {
    timeline.fromTo(
      elementRef.current,
      { yPercent: 50 },
      { yPercent: 0, clearProps: 'yPercent', ease: 'Power2.easeOut', duration: 0.5 },
    );
  }

  if (lineRef?.current) {
    timeline.fromTo(
      lineRef.current,
      { scaleX: 0 },
      {
        scaleX: 1,
        clearProps: 'scaleX',
        duration: 0.4,
        ease: 'Quad.easeInOut',
      },
      0.1,
    );
  }

  if (title) {
    timeline.add(title.getTimeline('in') as gsap.core.Timeline, 0);
  }
}
